import { useQuery } from "react-query";
import queryFn from "ApiLayer/Construction/queryBuildingModelConstruction";
import { useAccessToken } from "hooks/useAccessToken";
import { QUERY_STALE_TIME } from "utils/constants";

export const buildingModelConstructionQueryKey = ["buildingModelConstruction"];

export const useBuildingModelConstruction = (buildingModelUid: string) => {
    const accessToken = useAccessToken();
    return useQuery({
        queryKey: [...buildingModelConstructionQueryKey, buildingModelUid],
        queryFn: async () => queryFn(accessToken, buildingModelUid),
        staleTime: QUERY_STALE_TIME,
    });
};
